import { useCallback, useMemo } from 'react';
import { MFA_SESSION_KEY, MfaPendingResponse } from 'setup/mfaTypes';

type StoredMfaSession = MfaPendingResponse;

const readSession = (): StoredMfaSession | null => {
  const raw = sessionStorage.getItem(MFA_SESSION_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as StoredMfaSession;
  } catch {
    return null;
  }
};

export const useMfaSession = () => {
  const saveSession = useCallback((session: MfaPendingResponse) => {
    sessionStorage.setItem(MFA_SESSION_KEY, JSON.stringify(session));
  }, []);

  const clearSession = useCallback(() => {
    sessionStorage.removeItem(MFA_SESSION_KEY);
  }, []);

  const currentSession = useMemo(() => readSession(), []);

  return {
    currentSession,
    saveSession,
    clearSession,
  };
};
